module.exports = __webpack_public_path__ + "assets/img/micronet-member_2.3c994278.png";